import { supabase } from '@/integrations/supabase/client';

export const authService = {
  /**
   * Sign in with Google OAuth
   */
  async signInWithGoogle(returnTo?: string) {
    const redirectTo = returnTo 
      ? `${window.location.origin}/auth/callback?returnTo=${encodeURIComponent(returnTo)}`
      : `${window.location.origin}/auth/callback`;

    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo,
      },
    });

    return { error };
  },

  /**
   * Sign in with email/password
   */
  async signInWithPassword(email: string, password: string) {
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    return { error };
  },

  /**
   * Sign up with email/password
   */
  async signUp(email: string, password: string, fullName?: string) {
    const redirectUrl = `${window.location.origin}/auth/callback`;
    
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: redirectUrl,
        data: {
          full_name: fullName,
        },
      },
    });

    // If signup successful and full name provided, update profile
    if (!error && data.user && fullName) {
      const { error: profileError } = await supabase
        .from('profiles')
        .update({ full_name: fullName })
        .eq('user_id', data.user.id);
      
      if (profileError) {
        console.error('Error updating profile:', profileError);
      }
    }

    // Sync new user to GHL (fire and forget - don't block signup)
    if (!error && data.user) {
      supabase.functions.invoke('sync-user-to-ghl').catch((ghlError) => {
        console.error('GHL sync error:', ghlError);
      });
    }

    return { error };
  },

  /**
   * Reset password
   */
  async resetPassword(email: string) {
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/auth/callback?type=recovery`,
    });
    return { error };
  },
};
